import React, { useEffect, useState } from "react";
import {
  sendChatLogic,
  sendChatNotification,
  uploadChatImages,
} from "../../../store/features/chat/chatSlice";
import { getFullName, notify, playMessageSound } from "../../../util/helpers";
import S3FileUpload from "react-s3";
import { RtcTokenBuilder, RtmTokenBuilder } from "agora-access-token";

export const getRTCToken = (
  agoraID,
  agoraCertificate,
  uid,
  role,
  privilegeExpriyTime,
  channelName = null
) => {
  if (!channelName) {
    channelName = uid.toString();
  }
  let token = null;
  console.log("Agora ID: ", agoraID);
  console.log("Agora Certificate: ", agoraCertificate);
  try {
    token = RtcTokenBuilder.buildTokenWithUid(
      agoraID,
      agoraCertificate,
      channelName,
      uid.toString(),
      role,
      privilegeExpriyTime
    );
  } catch (e) {
    console.log(
      "Something went wrong while generating RTC token from Agora",
      e
    );
  }
  return token;
};

export const getToken = (
  agoraID,
  agoraCertificate,
  uid,
  role,
  privilegeExpriyTime
) => {
  let token = "";
  console.log("Agora ID: ", agoraID);
  console.log("Agora Certificate: ", agoraCertificate);
  try {
    token = RtmTokenBuilder.buildToken(
      agoraID,
      agoraCertificate,
      uid,
      role,
      privilegeExpriyTime
    );
  } catch (e) {
    console.log("Something went wrong while generating RTM Token", e);
  }
  return token;
};

export const chatStructureHelper = (
  item,
  filteredData,
  clinicianId,
  clinicianName,
  clinicAdmin
) => {
  const patientData = item?.patient_data;
  let structure = {};
  if (patientData) {
    const patientName = getFullName(patientData);
    const identifier = patientData["id"];
    const sentBy = (item?.sender === clinicianId || item?.sender === clinicAdmin) ? clinicianName : patientName;
    const messageStrucure = {
      message_type: item?.message_type,
      message: item?.message,
      created: item?.created,
      modified: item?.modified,
      sentBy: sentBy,
      messageId: item?.id,
      sender: item?.sender,
      to: item?.to,
      type: (item?.sender === clinicianId || item?.sender === clinicAdmin) ? "outgoing" : "incoming",
    };
    if (identifier in filteredData) {
      filteredData[identifier]["messages"].push(messageStrucure);
      if (item?.read_status === false) {
        if ("count" in filteredData[identifier]) {
          filteredData[identifier]["count"] += 1;
        } else {
          filteredData[identifier]["count"] = 1;
        }
      }
    } else {
      structure = {
        name: patientName,
        patient_id: patientData?.id,
        flag: patientData?.flag,
        profile_picture: patientData?.profile_picture,
        email: patientData?.email,
        latest_message:
          item?.message_type === "text" ? item?.message : "Sent an image",
        latest_message_time: new Date(item?.modified),
        sentBy: sentBy,
        messageId: item?.id,
        sender: item?.sender,
        to: item?.to,
        count: 0,
        messages: [messageStrucure],
        rose_chat: patientData?.rose_chat,
      };
      filteredData[identifier] = structure;
    }
    return structure;
  }
};

export const messageStrucureHelper = (
  item,
  clinicianId,
  clinicianName,
  patientName
) => {
  const messageStrucure = {
    message_type: item?.message_type,
    message: item?.message,
    created: new Date(), //TODO Send created from backend
    modified: new Date(), //TODO Send modified from backend
    sentBy: item?.sender === clinicianId ? clinicianName : patientName,
    messageId: item?.id || 9999999, //TODO Send messageID from backend
    sender: item?.sender,
    to: item?.to,
    type: item?.sender === clinicianId ? "outgoing" : "incoming",
  };

  return messageStrucure;
};

export const updateMessageInSidebar = (
  message,
  peerId,
  chatPatients,
  updateBadge,
  chatEnabledPatients = [],
  clinicianId = null
) => {
  try {
    peerId = parseInt(peerId);
    //*Checking if the patient's chat tile exists:
    let tempChatList = JSON.parse(JSON.stringify(chatPatients));
    let chatTile = tempChatList.findIndex(
      (chat) => chat?.patient_id === peerId
    );
    const now = new Date();
    if (chatTile !== -1) {
      tempChatList[chatTile].latest_message = message?.text;
      tempChatList[chatTile].latest_message_time = now;
      tempChatList[chatTile].modified = now.toISOString();
      tempChatList[chatTile].created = now.toISOString();
      if (updateBadge) {
        const currentCount = tempChatList[chatTile].count !== undefined && tempChatList[chatTile].count !== null
          ? parseInt(tempChatList[chatTile].count)
          : (tempChatList[chatTile].unread_count !== undefined && tempChatList[chatTile].unread_count !== null
              ? parseInt(tempChatList[chatTile].unread_count)
              : 0);
        tempChatList[chatTile].count = currentCount + 1;
        tempChatList[chatTile].unread_count = currentCount + 1;
      }

      //*Finally, notify the clinician about the new message
      if (updateBadge) {
        playMessageSound();
      }
    } else {
      //*Modify chatPatients state to include the new chatitem

      //*Create a strucutrue for the new message
      let msgObj = {
        message_type: message?.messageType,
        message: message?.text,
        created: now.toISOString(),
        modified: now.toISOString(),
        messageId: 9999999, //TODO: Change this be next after existing messages / 0 if it is a new message
        sender: peerId,
        to: clinicianId,
        type: "incoming",
      };

      //* Find the patient from the list of chat-enabled patients already made available with the first UE and update latest message details and add new message to list of messages for that patient.
      const findPatient = chatEnabledPatients.find(
        (patient) => patient?.patient_id === peerId
      );
      if (findPatient) {
        const clonedPatient = JSON.parse(JSON.stringify(findPatient));
        clonedPatient.latest_message = message?.text;
        clonedPatient.latest_message_time = now;
        clonedPatient.created = now.toISOString();
        clonedPatient.modified = now.toISOString();
        clonedPatient.sender = peerId;
        clonedPatient.messages = [msgObj];
        clonedPatient.to = clinicianId;
        clonedPatient.count = 1;
        clonedPatient.unread_count = 1;

        //*Add the new patient tile to the list of running chats in chatPatients state and update the state variable.
        tempChatList.push(clonedPatient);
      }

      //*Finally, notify the clinician about the new message
      playMessageSound();
    }
    return tempChatList;
  } catch (e) {
    console.log("Error while updating messages in sidebar\n", e);
    return chatPatients;
  }
};

// export const handleImageUploadToS3 = async (attachment, path) => {
//   const config = {
//     bucketName: process.env.REACT_APP_AWS_BUCKET,
//     dirName: path,
//     region: process.env.REACT_APP_AWS_REGION,
//     accessKeyId: process.env.REACT_APP_AWS_KEY_ID,
//     secretAccessKey: process.env.REACT_APP_AWS_SECRET,
//   };

//   if (!attachment) return;
//   S3FileUpload.uploadFile(attachment, config)
//     .then((data) => {
//       return data;
//     })
//     .catch((e) => {
//       console.log("Something went wrong while uploading to S3", e);
//     });
// };
export const handleImageUploadToS3 = async (attachment, path) => {
  if (!attachment) return null;

  const formData = new FormData();
  formData.append("file", attachment);
  formData.append("path", path); // Optional sub-folder

  try {
    const response = await fetch("/api/upload/", {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Failed to upload image");
    }

    const data = await response.json();
    return data.url; // This is the public S3 URL returned by backend
  } catch (e) {
    console.error("Something went wrong while uploading to backend", e);
    return null;
  }
};


export const sendMessage = async (
  type,
  peerID,
  message = null,
  setMessageSending = null,
  setMessageText = null,
  setClinicianChatMessage = null,
  clinicianId = null,
  attachment = null,
  setAttachment = null,
  patientEmail = null,
  senderName = null,
) => {
  const payloadMessageStructure = {
    message_type: type,
    message: message?.text,
    read_status: true,
    to: peerID.toString(),
    sender: clinicianId.toString(),
  };

  const rtmHelper = async (
    payload = payloadMessageStructure,
    text = message?.text
  ) => {
    try {
      // 1. Always save to Database first. This ensures the message is never "lost"
      // even if Agora RTM times out or fails (Error -11033).
      const res = await sendChatLogic(payload);
      if (res?.status === 201) {
        setClinicianChatMessage({
          messageType: type,
          text: text,
        });
      }

      // 2. Attempt to deliver via Agora RTM for real-time experience
      const client = window.agora;
      if (client && client.connectionState === "CONNECTED") {
        try {
          const sendResult = await client.sendMessageToPeer(
            {
              text: text,
              messageType: "TEXT",
            },
            peerID.toString()
          );

          if (!sendResult.hasPeerReceived && patientEmail) {
            // Patient is offline in RTM, send a notification (e.g. Email/Push)- not required notification already handled in chat-history
            // sendChatNotification(patientEmail).catch((e) =>
            //   console.log("Notification error", e)
            // );
          }
        } catch (e) {
          console.error("Agora RTM delivery error:", e.code, e.message);
          // Error -11033 (Timeout) is common on mobile web due to connection drops.
          // Since the message is already in the DB, we don't need to show a warning to the user.
        }
      } else {
        console.warn("Agora RTM not connected. Message saved to DB only.");
        // not required notification already handled in chat-history
        // if (patientEmail) {
        //   sendChatNotification(patientEmail).catch((e) =>
        //     console.log("Notification error", e)
        //   );
        // }
      }
    } catch (e) {
      console.error("Critical error in sendMessage:", e);
      notify(
        "Something went wrong while sending your message, try again later!",
        "warning"
      );
    }

    if (setAttachment) {
      setAttachment(null);
    }
  };

  try {
    setMessageSending(true);

    if (type === "image") {
      if (!attachment) return;

      const formData = new FormData();
      formData.append("file", attachment);
      formData.append("path", `${clinicianId}/${peerID}`);

      try {
        const res = await uploadChatImages(formData);
        const imageUrl = res?.data?.url;

        if (!imageUrl) {
          throw new Error("Image URL is missing in upload response");
        }

        const temp = { ...payloadMessageStructure };
        temp["message"] = `${imageUrl} [From : ${senderName}]`;
        await rtmHelper(temp, imageUrl);
      } catch (e) {
        console.error("Upload error", e);
        notify("Failed to upload image. Please try again.", "warning");
      }
    } else {
      await rtmHelper();
    }
  } catch (e) {
    console.log("Something went wrong while sending message", e);
  } finally {
    setMessageSending(false);
    setMessageText("");
  }
};
const AgoraClientComponent = ({ callback = null, setRemoteShow = null }) => {
  //*Chat Initialization stuff
  const [client, setClient] = useState(window?.agora);

  useEffect(() => {
    const interval = setInterval(() => {
      if (window?.agora !== client) {
        console.log("AgoraClientComponent: Syncing client state from window.agora", {
          oldClientExists: !!client,
          newClientExists: !!window?.agora
        });
        setClient(window?.agora);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [client]);

  useEffect(() => {
    if (!client) {
      console.log("AgoraClientComponent: No client available to bind listeners.");
      return;
    }

    console.log("AgoraClientComponent: Registering event listeners on client instance.");

    const handleConnectionStateChanged = async (data, data2) => {
      console.log("AgoraClientComponent: ConnectionStateChanged event detected:", {
        state: data,
        reason: data2
      });
      if (data === "ABORTED" && data2 === "REMOTE_LOGIN") {
        if (setRemoteShow) {
          console.log("AgoraClientComponent: Triggering DualLoginModal display (setRemoteShow to true).");
          setRemoteShow(true);
        }
      } else if (data === "CONNECTED") {
        if (setRemoteShow) {
          console.log("AgoraClientComponent: Auto-dismissing banner (setRemoteShow to false).");
          setRemoteShow(false);
        }
      }
    };

    const handleMessageFromPeer = (message, peerID) => {
      console.log(`${peerID} texted :`, message); //TODO: Remove this log once testing is completed!
      if (callback) {
        callback(message, peerID);
      }
    };

    client.on("ConnectionStateChanged", handleConnectionStateChanged);
    client.on("MessageFromPeer", handleMessageFromPeer);

    return () => {
      console.log("AgoraClientComponent: Cleaning up event listeners from client instance.");
      client.off("ConnectionStateChanged", handleConnectionStateChanged);
      client.off("MessageFromPeer", handleMessageFromPeer);
    };
  }, [client, callback, setRemoteShow]);

  return <></>;
};

export default AgoraClientComponent;
